'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'mug-saucer';
var width = 640;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = 'M416 64l16 0 16 0 0 160 0 32 0 96-320 0 0-288 288 0zm64 288l0-96 48 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0-32 0-16 0-16 0L128 32 96 32l0 32 0 288 0 32 32 0 320 0 32 0 0-32zm48-128l-48 0 0-160 48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448L0 448l0 32 16 0 544 0 16 0 0-32-16 0L16 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;